import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import GeoInfoService from 'ck-core-web/source/services/GeoInfoService';
import CurrencyPropType from './CurrencyPropType.jsx';

export default function(WrappedComponent) {
	class WithCurrency extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				currency:
					this.props.currency ||
					CK.user.paymentCurrency() ||
					(GeoInfoService.mod() && GeoInfoService.mod().state.currency()) ||
					CK.testCurrency
			};

			this.handleGeoInfoChange = this.handleGeoInfoChange.bind(this);
			this.checkUserCurrencyChange = this.checkUserCurrencyChange.bind(this);
		}

		checkUserCurrencyChange() {
			this.setState(prevState => {
				if (
					!prevState.currencyManuallyChosen &&
					CK.user.paymentCurrency() &&
					prevState.currency !== CK.user.paymentCurrency()
				) {
					return {
						currency: CK.user.paymentCurrency()
					};
				}
			});
		}

		componentDidMount() {
			CK.user && CK.user.$bind(this.checkUserCurrencyChange);

			if (!this.props.allowCurrencyChange) {
				const geoInfo = GeoInfoService.mod();

				if (geoInfo) {
					geoInfo.state.$bind(this.handleGeoInfoChange);
				}

				this.handleGeoInfoChange();
			}
		}

		componentWillUnmount() {
			CK.user && CK.user.$unbind(this.checkUserCurrencyChange);

			const geoInfo = GeoInfoService.mod();

			if (geoInfo) {
				geoInfo.state.$unbind(this.handleGeoInfoChange);
			}
		}

		handleGeoInfoChange() {
			const geoInfo = GeoInfoService.mod();

			if (geoInfo) {
				this.setState(prevState => {
					if (CK.user && !CK.user.paymentCurrency() && !prevState.currencyManuallyChosen) {
						return {
							currency: geoInfo.state.currency()
						};
					}
				});
			}
		}

		render() {
			const props = _.defaults(
				{
					currency: this.state.currency
				},
				this.props
			);

			return (
				<WrappedComponent
					{...props}
					handleCurrencyChange={currency =>
						this.setState({ currency, currencyManuallyChosen: true })
					}
				/>
			);
		}
	}

	WithCurrency.propTypes = {
		currency: CurrencyPropType,
		allowCurrencyChange: PropTypes.bool
	};

	return WithCurrency;
}
